import { StandardProgress, StudentProgressSummary } from './types';
import { mockStandards } from './mockStandards';
import { studentLearningPaths } from './mockStudentLearningPaths';

// Generate mock progress data for students
export const mockStudentProgress: StudentProgressSummary[] = [
  // Student 001 Progress
  {
    studentId: 'student-001',
    completedStandards: 3,
    totalStandards: 12,
    completionPercentage: 25,
    averageAccuracy: 78,
    lastUpdated: new Date().toISOString(),
    streak: 5,
    completedTasks: 15,
    weeklyProgress: [
      { date: new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0], standardsCompleted: 1 },
      { date: new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0], standardsCompleted: 1 },
      { date: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0], standardsCompleted: 1 },
      { date: new Date().toISOString().split('T')[0], standardsCompleted: 0 }
    ],
    pathProgress: [
      {
        pathId: 'student-path-001',
        pathName: 'Math Foundations',
        standardsCompleted: 2,
        totalStandards: 4,
        completionPercentage: 50
      },
      {
        pathId: 'student-path-002',
        pathName: 'Advanced Problem Solving',
        standardsCompleted: 1,
        totalStandards: 4,
        completionPercentage: 25
      },
      {
        pathId: 'student-path-003',
        pathName: 'Geometry Exploration',
        standardsCompleted: 0,
        totalStandards: 3,
        completionPercentage: 0
      },
      {
        pathId: 'student-path-004',
        pathName: 'Measurement Mastery',
        standardsCompleted: 0,
        totalStandards: 3,
        completionPercentage: 0
      }
    ]
  },
  
  // Student 002 Progress
  {
    studentId: 'student-002',
    completedStandards: 4,
    totalStandards: 9,
    completionPercentage: 44,
    averageAccuracy: 85,
    lastUpdated: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString(),
    streak: 3,
    completedTasks: 12,
    weeklyProgress: [
      { date: new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0], standardsCompleted: 1 },
      { date: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0], standardsCompleted: 1 },
      { date: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0], standardsCompleted: 2 },
      { date: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date().toISOString().split('T')[0], standardsCompleted: 0 }
    ],
    pathProgress: [
      {
        pathId: 'student-path-005',
        pathName: 'Number Sense Foundations',
        standardsCompleted: 2,
        totalStandards: 3,
        completionPercentage: 67
      },
      {
        pathId: 'student-path-006',
        pathName: 'Fraction Fundamentals',
        standardsCompleted: 1,
        totalStandards: 4,
        completionPercentage: 25
      },
      {
        pathId: 'student-path-007',
        pathName: 'Data Analysis',
        standardsCompleted: 1,
        totalStandards: 2,
        completionPercentage: 50
      }
    ]
  },
  
  // Student 003 Progress
  {
    studentId: 'student-003',
    completedStandards: 2,
    totalStandards: 5,
    completionPercentage: 40,
    averageAccuracy: 72,
    lastUpdated: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString(),
    streak: 1,
    completedTasks: 8,
    weeklyProgress: [
      { date: new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0], standardsCompleted: 1 },
      { date: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0], standardsCompleted: 1 },
      { date: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date().toISOString().split('T')[0], standardsCompleted: 0 }
    ],
    pathProgress: [
      {
        pathId: 'student-path-008',
        pathName: 'Multiplication Mastery',
        standardsCompleted: 1,
        totalStandards: 3,
        completionPercentage: 33
      },
      {
        pathId: 'student-path-009',
        pathName: 'Time and Money',
        standardsCompleted: 1,
        totalStandards: 2,
        completionPercentage: 50
      }
    ]
  },
  
  // Student 004 Progress
  {
    studentId: 'student-004',
    completedStandards: 1,
    totalStandards: 5,
    completionPercentage: 20,
    averageAccuracy: 88,
    lastUpdated: new Date(new Date().setDate(new Date().getDate() - 4)).toISOString(),
    streak: 0,
    completedTasks: 3,
    weeklyProgress: [
      { date: new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0], standardsCompleted: 1 },
      { date: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0], standardsCompleted: 0 },
      { date: new Date().toISOString().split('T')[0], standardsCompleted: 0 }
    ],
    pathProgress: [
      {
        pathId: 'student-path-010',
        pathName: 'Comprehensive Math Review',
        standardsCompleted: 1,
        totalStandards: 5,
        completionPercentage: 20
      }
    ]
  }
];

// Helper function to get progress for a specific student
export const getStudentProgress = (studentId: string): StudentProgressSummary | undefined => {
  return mockStudentProgress.find(progress => progress.studentId === studentId);
};

// Helper function to calculate completion percentage for a student and learning path
export const calculatePathCompletionPercentage = (studentId: string, pathId: string): number => {
  const progress = mockStudentProgress.find(p => p.studentId === studentId);
  if (!progress) return 0;
  
  const pathProgress = progress.pathProgress.find(p => p.pathId === pathId);
  return pathProgress ? pathProgress.completionPercentage : 0;
};
